<template>
    <div class="page">
        <header>
            <img src="../../../../assets/key/key.png" alt="">
            <strong>{{bindName}}</strong>
        </header>

        <main>
            <div class="title">
                <img src="../../../../assets/key/person.png" alt="">
                接收人信息
            </div>

            <div class="list-item">
                <div>接收人姓名</div>
                <el-input v-model="name"></el-input>
            </div>

            <div class="list-item">
                <div>接收人电话</div>
                <el-input v-model="phone" type="number" :disabled="!canInput"></el-input>
            </div>

            <div class="list-item">
                <div>选择结束日期</div>
                <el-date-picker
                        :picker-options="pickerOptions"
                        :editable="false"
                        class="add"
                        v-model="authEnd"
                        type="date"
                        placeholder="选择结束日期">
                </el-date-picker>
            </div>

            <div class="list-item">
                <div>次数选择</div>
                <div>
                    <el-radio v-model="select" label="0">无限次</el-radio>
                    <el-radio v-model="select" label="1">有限次</el-radio>
                </div>
            </div>

            <div class="list-item" v-if="isShowInput">
                <div>请输入次数</div>
                <el-input v-model="authTimes" type="number"></el-input>
            </div>
            <!-- <div class="list-item" >
                <div>请输入备注</div>
                <el-input v-model="comment" type="number"></el-input>
            </div> -->
        </main>

        <div class="submit" @click="op">{{title}}</div>

    </div>
</template>

<script>
    import {Message} from 'element-ui';
    import axios from "axios";

    export default {
        name: "Share",

        data() {
            return {

                bindName: "",

                name: "",

                phone: "",

                leaseID: "",
                userID: "",
                bindID:'',
                devID:'',
                orgID:'',

                authEnd: "",
                authEndLimit: "",
                comment:'',

                authTimes: 0,

                select: "0",

                canInput: true,
                optioDdata:'',
                title:''
            }
        },

        created() { 
            document.title = "分享钥匙";
            this.title = "分享钥匙";
           

            let data = JSON.parse(decodeURI(this.$route.query.data));
            this.optioDdata = JSON.parse(decodeURI(this.$route.query.data))
            this.bindName = data.bindName;
            this.leaseID = data.leaseID;
            this.authEndLimit = data.authEnd;
            this.devID = data.devID;
            this.bindID = data.bindID;
           this.orgID = data.orgID;

            localStorage.setItem("token", this.$route.query.token || "");
            localStorage.setItem("orgID", this.orgID || "");
            localStorage.setItem("type", this.$route.query.client || "");
            //如果有电话号码，则为编辑
            if (data.phone) {
                console.log(data)
                document.title = "编辑分享钥匙";
                this.title = "编辑分享钥匙";
                this.name = data.name;
                this.phone = data.phone;
                this.comment = data.comment;
                this.authTimes = data.authTimes;
                if(this.authTimes > 0) {
                    this.select = "1"
                }

                this.authEndLimit = data.rentEnd;
                this.userID = data.userID;
                this.authEnd = new Date(data.authEnd * 1000);

                this.canInput = false;

            }

            this.reset();
        },

        computed: {
                
            isShowInput() {
                return this.select === "1";
            },

            pickerOptions(){
                let vue = this;
                return {
                    disabledDate(time) {
                        return time.getTime() < Date.now()
                            || time.getTime() > new Date(vue.authEndLimit * 1000);
                    }
                }
            }
        },

        methods: {

            device() {
                const u = navigator.userAgent;
                const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid)
                    return 'android';
                if (isiOS)
                    return 'ios';
            },

            reset() {
                let isReset = true;

                if (this.device() === 'ios') {
                    document.body.addEventListener('focusin', () => {
                        //软键盘弹出的事件处理
                        isReset = false;
                    });
                    document.body.addEventListener('focusout', () => {
                        //软键盘收起的事件处理
                        isReset = true;
                        setTimeout(() => {
                            //当焦点在弹出层的输入框之间切换时先不归位
                            if (isReset) {
                                window.scroll(0, 0);//失焦后强制让页面归位
                            }
                        }, 300);
                    });
                }
            },

            op() { 
                if (this.canInput) {
                    this.submit();
                }
                else {
                    this.edit();
                }
            },

            edit() {
                if (this.name === "") {
                    Message.warning("请输入接收人姓名");
                    return;
                }
                if (this.phone === "") {
                    Message.warning("请输入接收人电话");
                    return;
                }
                if (this.authEnd === "") {
                    Message.warning("请选择结束日期");
                    return;
                }
                if (this.select === "1" && this.authTimes < 0) {
                    Message.warning("请输入正确的次数");
                    return;
                }

                if (this.select === "0") {
                    this.authTimes = 0;
                }

                let authEnd = new Date(this.authEnd);
                if (authEnd.getHours() < 10) {
                    //结束时间添加10个小时
                    authEnd = authEnd/1000 + 10 * 60 * 60;
                }
                else {
                    authEnd = authEnd/1000;
                }
                authEnd = parseInt(authEnd);
                let url = axios.defaults.baseURL.replace('v1/org/','')
                axios({
                    method: 'post',
                    url: url+"v2/visitors/edit",
                    headers: {
                        'Authorization': this.$route.query.token,
                        'PYDDot-Client-Type':this.$route.query.client,
                        'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
                        },

                    data: {
                        "orgID": this.optioDdata.orgID,
                        "id": this.userID,
                        "authUserName": this.name,
                        'comment':this.comment, 
                        "authStart": parseInt(new Date().getTime()/1000),
                        "authEnd": authEnd,
                        "authTimes": parseInt(this.authTimes)
                    },
                }).then(value => {
                    if (value.data.code === 0) {
                        Message.success("编辑成功");
                    }
                    else {
                        Message.error(value.data.message);
                    }

                }).catch(reason => {
                    Message.error(reason.toString());
                });
            },

            submit() { 
                if (this.name === "") {
                    Message.warning("请输入接收人姓名");
                    return;
                }
                if (this.phone === "") {
                    Message.warning("请输入接收人电话");
                    return;
                }
                if (this.authEnd === "") {
                    Message.warning("请选择结束日期");
                    return;
                }
                if (this.select === "1" && this.authTimes < 0) {
                    Message.warning("请输入正确的次数");
                    return;
                }

                if (this.select === "0") {
                    this.authTimes = 0;
                } 
                let url = axios.defaults.baseURL.replace('v1/org/','')
                axios({
                    method: 'post',
                    url: url+"v2/visitors/add",
                    headers: {
                        'Authorization': this.$route.query.token,
                        'PYDDot-Client-Type':this.$route.query.client,
                        'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
                        },

                    data: {
                        "leaseID": this.leaseID,
                        "authUserName": this.name,
                        "authUserPhone": this.phone,
                        "authStart": parseInt(new Date().getTime()/1000),
                        //结束时间添加10个小时
                        "authEnd": parseInt(new Date(this.authEnd)/1000 + 10 * 60 * 60),
                        "authTimes": parseInt(this.authTimes),
                        'comment':this.comment,
                        'orgID': this.optioDdata.orgID,
                        'bindType':'房源',
                        'devID':this.devID,
                        'bindID':this.bindID
                        
                    },
                }).then(value => {
                    if (value.data.code === 0) {
                        Message.success("分享成功");
                        this.name = "";
                        this.phone = "";
                        this.authEnd = "";
                        this.authTimes = 0;
                        this.select = "0";
                        this.comment = ''
                    }
                    else {
                        Message.error(value.data.message);
                    }

                }).catch(reason => {
                    Message.error(reason.toString());
                });
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

    header {
        position: sticky;
        top: 0;
        width: 90%;
        border-radius: 10px;
        margin: 30px auto auto;
        padding-left: 14px;
        padding-right: 14px;
        align-items: center;
        color: white;
        box-sizing: border-box;
        background: $colorDefault;
        height: 44px;
        display: flex;
        img {
            margin-right: 10px;
            height: 22px;
            width: 22px;
        }
    }

    main {
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        align-items: center;
        box-sizing: border-box;
        padding: 20px;
        margin: auto;
        width: 90%;
        background: white;
        .title {
            justify-content: center;
            align-items: center;
            display: flex;
            font-size: 20px;
            img {
                width: 30px;
            }
        }
    }

    .submit {
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        border-radius: 20px;
        margin: 40px auto 0;
        width: 60%;
        background: $colorDefault;
        height: 44px;
    }

    .el-input {
        max-width: 170px;
    }

    .list-item {
        margin-top: 14px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .list-item-name {
            color: $fontColor-9;
        }
        .list-item-value {
            color: $fontColor-3;
        }
    }

    .el-date-picker {
        position: fixed;
        bottom: 0;
    }

</style>
